import { useState, useEffect } from "react";

import { fetchLiveblogFromApi } from "~api/client/fetchLiveblogFromApi";
import type { LiveBlog } from "~types/types";

export function useLiveBlog(blogId?: string, postCount?: number) {
    const [loadingStatus, setLoadingStatus] = useState({
        loading: false,
        loaded: false,
        failed: false,
    });
    const [liveBlog, setLiveBlog] = useState<LiveBlog | null>(null);

    useEffect(() => {
        const controller = new AbortController();

        if (blogId) {
            fetchLiveblogFromApi({ blogId, postCount })
                .then((response) => {
                    setLiveBlog(response as unknown as LiveBlog);

                    if (response) {
                        setLoadingStatus({
                            loading: false,
                            loaded: true,
                            failed: false,
                        });
                    } else {
                        setLoadingStatus({
                            loading: false,
                            loaded: false,
                            failed: true,
                        });
                    }
                })
                .catch(() =>
                    setLoadingStatus({
                        loading: false,
                        loaded: false,
                        failed: true,
                    })
                );
        }

        return () => {
            controller.abort();
            setLoadingStatus({
                loading: false,
                loaded: false,
                failed: false,
            });
        };
    }, [blogId, postCount]);

    return { liveBlog, loadingStatus };
}
